export default "__VITE_ASSET__BvnKk9H7__"